import { render, staticRenderFns } from "./PptRichTextAttr.vue?vue&type=template&id=1f3b86db&"
import script from "./PptRichTextAttr.vue?vue&type=script&lang=js&"
export * from "./PptRichTextAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/attr/PptRichTextAttr.vue"
export default component.exports